/* ===========================================================================
   DRINEA — Calculateur de taille (porté du master drinea-site).
   Mappe le tour de hanches sur la grille S..2XL. Le tour de taille sert de
   garde-fou (il faut au moins taille + hanches), la hauteur ajuste le conseil.
   Seuils hanches : <98 S · <106 M · <114 L · <122 XL · sinon 2XL.
   =========================================================================== */
(function () {
  function recommendSize(hips) {
    if (hips < 98) return 'S';
    if (hips < 106) return 'M';
    if (hips < 114) return 'L';
    if (hips < 122) return 'XL';
    return '2XL';
  }

  function initCalculator(root) {
    var btn = root.querySelector('[data-calc-btn]');
    if (!btn) return;
    var waistEl = root.querySelector('[data-calc-waist]');
    var hipsEl = root.querySelector('[data-calc-hips]');
    var heightEl = root.querySelector('[data-calc-height]');
    var resEl = root.querySelector('[data-calc-res]');
    var msgEl = root.querySelector('[data-calc-msg]');

    btn.addEventListener('click', function () {
      var waist = +(waistEl && waistEl.value);
      var hips = +(hipsEl && hipsEl.value);
      var height = +(heightEl && heightEl.value);

      if (!waist || !hips) {
        if (resEl) resEl.textContent = '—';
        if (msgEl) msgEl.textContent = 'Renseignez au moins taille et hanches';
        return;
      }

      var size = recommendSize(hips);
      if (resEl) resEl.textContent = size;
      if (msgEl) {
        msgEl.textContent = (height && height > 174)
          ? 'Astuce : pour votre hauteur, privilégiez la taille au-dessus.'
          : 'Taille recommandée pour un maintien confortable.';
      }

      /* Surligne la pastille taille correspondante dans la buy box si présente. */
      var sizeButtons = document.querySelectorAll('[data-size-value]');
      sizeButtons.forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-size-value') === size);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-size-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
